import { render, staticRenderFns } from "./news-page.vue?vue&type=template&id=500a7ca1&"
import script from "./news-page.vue?vue&type=script&lang=js&"
export * from "./news-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports